import { z } from 'zod';
import { BasePinSchema, BasePinSettingsSchema } from './base-pin';
import { DbClassicPinTypeSchema } from './classic-pin';

export const UnsupportedPinSettingsSchema = BasePinSettingsSchema.extend(
  z.object({
    layout: z.null().optional(),
    originalType: DbClassicPinTypeSchema,
  }).shape
);

export type UnsupportedPinSettings = z.infer<typeof UnsupportedPinSettingsSchema>;

export const UnsupportedPinTypeSchema = z.literal('UNSUPPORTED');

export const UnsupportedPinSchema = BasePinSchema.extend(
  z.object({
    type: UnsupportedPinTypeSchema,
    settings: UnsupportedPinSettingsSchema,
  }).shape
);

export type UnsupportedPin = z.infer<typeof UnsupportedPinSchema>;
